import { Optional } from "common/utils/types";
import { SubscriptionFrequency } from "common/types";
import { ClientCartDetail } from "common/types/carts";
import { FetchError } from "common/fetch/types";

import { IClient } from "client/accounts/types";
import { Clinic } from "client/clinics/types";
import { CartRefillTooSoonSummary } from "client/carts/types";

export enum CheckoutStep {
  Items = "items",
  Delivery = "delivery",
  Payment = "payment",
}

export interface CheckoutStepProps {
  cart: ClientCartDetail;
  client: IClient;
  clinic: Clinic;
  onPrevious: () => void;
  onNext: () => void;
  isValid: boolean;
  isLoading: boolean;
  taxError: Optional<FetchError>;
  taxAmount: Optional<number>;
  refillTooSoonSummary: CartRefillTooSoonSummary;
}

export interface OptionType {
  [key: string]: Optional<number>;
}

export interface SubscriptionOptionType {
  [key: string]: SubscriptionFrequency;
}

export type DeliveryCheckoutSubStepProps = Omit<CheckoutStepProps, "onNext"> & {
  onNext: (nextCart: ClientCartDetail) => void;
};

export type CheckoutErrorSearch = {
  status?: number;
};

export type KlarnaCheckoutSearch = {
  redirect_status?: string;
};
/** Possible url param values on 'redirect_status' on redirect from Klarna checkout completion
 * see: https://stripe.com/docs/api/sources/object#source_object-redirect for 'redirect.status'
 */
export enum KlarnaRedirectParams {
  Succeeded = "succeeded",
  Pending = "pending",
  Failed = "failed",
}
